// Thème clair / sombre.
//
// L'application s'ouvre en mode SOMBRE : c'est le CSS qui le pose
// (`color-scheme: dark` dans `tokens.css`), sans une ligne de JavaScript, et
// sans regarder le réglage du système. Ce module ne sert qu'au CHOIX EXPLICITE :
// le bouton de l'en-tête pose `data-theme` sur <html> et le mémorise pour ce
// navigateur.
import { useState } from 'react';
import { savePreference } from '../legal/cookieConsent';

export type Theme = 'light' | 'dark';
const KEY = 'ro.theme';
const DEFAULT: Theme = 'dark';

// Préférence PAR NAVIGATEUR, simple confort : le stockage peut être indisponible
// (navigation privée, stockage bloqué) — on garde alors le thème par défaut.
function stored(): Theme | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : null;
  } catch {
    return null;
  }
}

/** À appeler AVANT le premier rendu : applique le choix mémorisé, s'il y en a un. */
export function applyStoredTheme() {
  const t = stored();
  if (t) document.documentElement.dataset.theme = t;
}

/** Le thème affiché, et de quoi le basculer. */
export function useTheme(): { theme: Theme; toggle: () => void } {
  const [theme, setTheme] = useState<Theme>(() => stored() ?? DEFAULT);

  function toggle() {
    const next: Theme = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    // Mémorisé seulement si le visiteur a accepté ; sinon il vaut pour cette page.
    savePreference(KEY, next);
    setTheme(next);
  }

  return { theme, toggle };
}
